<!--
    描述：租户用户
    时间：2021-04-16
    Created by zwh
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header superiors-search-area">
			<div class="left-text overflow-hidden">
				<span><b>单位用户</b></span>
			</div>
			<search-area ref="searchContent"
						 v-model="searchForm.userName"
						 placeholderName="人员姓名"
						 @on-search="onSearch"
						 @on-refresh="onRefresh"
						 @on-reset="onReset"
						 :showMore="false">
			</search-area>
			<div class="ml5 btnGroups">
				<el-button type="success"
						   size="small"
						   v-if="roleBtns.includes('tenant_user_add')"
						   @click="doClick('', 'add')">新增用户</el-button>
			</div>
		</div>

		<div class="w-page-container pdb10">
			<div class="w-table-layout">
				<div class="w-table-content"
					 ref="tableContent">
					<el-table ref="table"
							  v-loading="tableObj.loading"
							  :data="tableObj.tableData"
							  default-expand-all
							  :height="tableObj.tableH"
							  row-key="id"
							  border
							  highlight-current-row>
						<el-table-column type="index"
										 align="center"
										 width="50"></el-table-column>
						<el-table-column prop="sname"
										 label="姓名"
										 align="center"
										 header-align="center"
										 show-overflow-tooltip
										 min-width="100"></el-table-column>
						<el-table-column prop="userName"
										 label="用户名"
										 align="center"
										 header-align="center"
										 show-overflow-tooltip
										 min-width="100"></el-table-column>
						<el-table-column prop="phone"
										 label="手机号"
										 align="center"
										 header-align="center"
										 show-overflow-tooltip
										 min-width="100"></el-table-column>
						<el-table-column prop="sex"
										 label="性别"
										 header-align="center"
										 align="center"
										 show-overflow-tooltip
										 min-width="80">
							<template slot-scope="scope">
								<div v-if="scope.row.sex">{{ parseInt(scope.row.sex) === 1 ? '男' : '女' }}</div>
								<div v-else></div>
							</template>
						</el-table-column>
						<el-table-column prop="age"
										 label="年龄"
										 header-align="center"
										 align="center"
										 show-overflow-tooltip
										 min-width="80"></el-table-column>
						<el-table-column prop="orChargeUser"
										 label="负责人"
										 show-overflow-tooltip
										 align="center"
										 min-width="80">
							<template slot-scope="scope">
								<span v-if="scope.row.orChargeUser">是</span>
								<span v-if="!scope.row.orChargeUser">否</span>
							</template>
						</el-table-column>
						<el-table-column prop="orEnable"
										 label="账号状态"
										 align="center"
										 show-overflow-tooltip
										 width="95">
							<template slot-scope="scope">
								<span v-show="(scope.row.orEnable === 0)"
									  style="color: #ff0000">禁用</span>
								<span v-show="(scope.row.orEnable === 1)"
									  style="color: #69c80c">启用</span>
							</template>
						</el-table-column>
						<el-table-column label="操作"
										 align="center"
										 show-overflow-tooltip
										 min-width="80">
							<template slot-scope="scope">
								<el-button size="mini"
										   icon="el-icon-edit"
										   title="编辑"
										   type="text"
										   v-if="roleBtns.includes('tenant_user_edit')"
										   @click="doClick(scope.row, 'edit')"></el-button>
								<el-button size="mini"
										   icon="el-icon-delete"
										   title="删除"
										   type="text"
										   v-if="roleBtns.includes('tenant_user_delete') && !scope.row.orChargeUser"
										   @click="doClick(scope.row, 'delete')"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="tableObj.currentPage"
								   :page-sizes="tableObj.pageList"
								   :page-size="tableObj.pageSize"
								   layout="total, sizes, prev, pager, next, jumper"
								   :total="tableObj.total"></el-pagination>
				</div>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 弹窗组件 -->
			<tenantUserAddDialog ref="tenantUserAddDialog"
								 v-if="dialogObj.visible && dialogObj.type === 'tenant'"
								 :mode="dialogObj.mode"
								 :transObj="transObj"
								 @handle-success="handleSuccess"
								 @on-fasle="handleFasle"></tenantUserAddDialog>

			<!-- 人员 -->
			<UserInfo v-if="dialogObj.visible && dialogObj.type === 'user'"
					  ref="userForm"
					  :mode="dialogObj.mode"
					  :currentRow="currentRow"
					  :userId="currentId"
					  :tenantInfo="tenantInfo"></UserInfo>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="handleClose">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">保 存</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import searchArea from '@/components/searchArea/searchArea'
import tenantUserAddDialog from './tenant_user_add_dialog'
import UserInfo from '../../public/user_dialog.vue'
import {
	getUserTenantTablePageListByTenantId,
	deleteBy2Id,
	updateUserTenantOrEnable,
} from 'api/system/sysUserTenant.js'

export default {
	components: { searchArea, tenantUserAddDialog, UserInfo },
	data() {
		return {
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '550px',
				mode: 'add',
				type: 'tenant',
			},
			currentRow: {},
			currentId: '',
			tableObj: {
				loading: false,
				tableH: 200,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100], // 显示条数数组

				expandKeys: [],
			},
			tenantInfo: null,
			searchForm: {
				userName: '',
			},

			transObj: {
				tenantId: '',
				limitId: '',
			},
			//租户点击对象
			clickTenantObj: '',
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight - 45
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.tableContent.offsetHeight - 45
		},
	},
	methods: {
		//初始方法
		initTrans(obj) {
			this.tenantInfo = obj
			this.clickTenantObj = obj
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.searchForm.userName = ''
			//获取租户用户列表信息
			//this.getTablePageList()
			this.$refs.searchContent.sname = ''
			this.onRefresh()
		},

		//获取租户用户列表信息
		getTablePageList() {
			if (this.clickTenantObj == '') {
				this.tableObj.tableData = []
				this.tableObj.total = 0
				this.transObj.tenantId = ''
				return
			}
			let param = {
				tenantId: this.clickTenantObj.id,
				current: this.tableObj.currentPage,
				size: this.tableObj.pageSize,
				sname: this.searchForm.userName,
			}
			getUserTenantTablePageListByTenantId(param).then((res) => {
				if (res.operationCode == 1) {
					this.tableObj.tableData = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},

		//点击事件
		doClick(row, type) {
			if (type == 'add') {
				if (this.clickTenantObj == '') {
					this.transObj.tenantId = ''
					this.transObj.limitId = ''
					this.$message({
						message: '请选择单位信息！',
						type: 'warning',
					})
					return
				}
				this.dialogObj.title = '新增单位用户'
				this.dialogObj.visible = true
				this.dialogObj.mode = 'add'
				this.dialogObj.type = 'tenant'
				this.transObj.tenantId = this.clickTenantObj.id
				this.transObj.limitId = this.clickTenantObj.limitId
			} else if (type == 'delete') {
				this.delete(row)
			} else if (type === 'edit') {
				this.currentId = row.userId
				this.dialogObj.title = '编辑用户信息'
				this.dialogObj.visible = true
				this.dialogObj.width = '80%'
				this.dialogObj.mode = 'add'
				this.dialogObj.type = 'user'
				this.$nextTick(() => {
					this.$refs.userForm.getRoleData()
					this.currentRow = this.$utils.clone(row, true)
				})
			}
		},

		//删除
		delete(row) {
			let that = this
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				let param = {
					userId: row.userId,
					tenantId: row.tenantId,
				}
				deleteBy2Id(param).then((res) => {
					if (res.operationCode == 1) {
						this.$message({
							message: '删除成功！',
							type: 'success',
						})
						this.getTablePageList()
					}
				})
			})
		},

		//是否启用
		orEnableChange(val, row) {
			this.$confirm(
				'确认' + (val == 1 ? '启用' : '禁用') + '吗?',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					let param = {
						userId: row.userId,
						tenantId: row.tenantId,
						orEnable: val,
					}
					updateUserTenantOrEnable(param).then((res) => {
						if (res.operationCode == 1) {
							this.$message({
								message: (val == 1 ? '启用' : '禁用') + '成功',
								type: 'success',
							})
							this.getTablePageList()
						}
					})
				})
				.catch((action) => {
					if (val == 0) row.orEnable = 1
					else row.orEnable = 0
				})
		},

		//保存点击事件
		async doSave() {
			if (this.dialogObj.type === 'tenant') {
				this.btnLoading = true
				this.$refs.tenantUserAddDialog.doSave()
			} else if (this.dialogObj.type === 'user') {
				this.btnLoading = true
				let status = await this.$refs.userForm.returnUserInfo()
				if (status) {
					this.btnLoading = false
					this.getTablePageList()
					this.handleClose()
				} else {
					this.btnLoading = false
				}
			}
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getTablePageList()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.getTablePageList()
		},

		// 确认搜索
		onSearch() {
			this.getTablePageList()
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.searchForm.userName = ''
		},

		//成功回调事件
		handleSuccess() {
			this.dialogObj.visible = false
			this.btnLoading = false
			this.getTablePageList()
		},

		//失败回调事件
		handleFasle(data) {
			this.btnLoading = data
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
			this.dialogObj.title = ''
			this.dialogObj.type = 'tenant'
			this.dialogObj.mode = 'add'
			this.dialogObj.width = '550px'
		},
	},
}
</script>
